export function svgMaps() {
  const tooltip = document.querySelector(".map-tooltip");
  const lotInfo = tooltip.querySelector(".lot-info");
  const sizeInfo = tooltip.querySelector(".size-info");
  const squareInfo = tooltip.querySelector(".square-info");
  const closeBtn = tooltip.querySelector(".close");
  const linkWrap = tooltip.querySelector(".link-wrap");

  function showTooltip(el, posX, posY) {
    let
      self = el,
      lot = self.getAttribute("data-lot") || "",
      size = self.getAttribute("data-size") || "",
      square = self.getAttribute("data-square") || "",
      linkHref = self.getAttribute("data-link-href") || "",
      linkText = self.getAttribute("data-link-text") || "",
      linkTarget = self.getAttribute("data-link-target") || "",
      windowWidth = window.innerWidth,
      tooltipWidth,
      sumPosition,
      top,
      left,
      indent = 30;

    left = posX;
    top = posY;
    lotInfo.innerText = lot;
    sizeInfo.innerText = size;
    squareInfo.innerText = square;
    linkWrap.innerHTML = "";
    if(linkHref) {
      const link = document.createElement("a");
      link.setAttribute("href", linkHref);
      link.innerText = linkText;
      if(linkTarget) {
        link.setAttribute("rel", "nofollow");
        link.setAttribute("target", linkTarget);
      }
      linkWrap.appendChild(link);
    }
    tooltipWidth = tooltip.offsetWidth || 250;
    sumPosition = left + tooltipWidth;
    left = sumPosition > windowWidth ? (left - (sumPosition - windowWidth)) : left;
    tooltip.style.left = left - indent + "px";
    tooltip.style.top = top + indent + "px";
    tooltip.style.display = "block";

    closeBtn.focus();
  }

  function hideTooltip() {
    tooltip.style.display = "none";
  }

  const lot = document.querySelectorAll("[data-lot]");

  [...lot].map((item) => {
    item.addEventListener("click", function(e) {
      const left = e.clientX + window.pageXOffset;
      const top = e.clientY + window.pageYOffset;
      showTooltip(this, left, top);
    });
    item.addEventListener("keyup", function(e) {
      if (e.which === 13) {
        showTooltip(this);
      }
    });
  });

  document.addEventListener("click", function(e) {
    if (e.target && e.target.className === "close") {
      hideTooltip();
    }
  });
  document.addEventListener("keyup", function(e) {
    if (e.which === 27) {
      hideTooltip();
    }
  });
  window.addEventListener("resize", function() {
    hideTooltip();
  });
}



// WEBPACK FOOTER //
// ./assets/js/modules/svgMaps.js